import React, { FunctionComponent, ReactNode, useState } from "react";
import { HiChevronDown, HiChevronUp, HiOutlineQuestionMarkCircle } from "react-icons/hi";

const PHONE_STEPS: ReactNode[] = [
  "Open the Google Maps app and find your office.",
  "Press and hold on the building until a red pin drops.",
  <>
    Tap <strong>Share</strong>, then <strong>Copy link</strong> (iPhone: <strong>Copy</strong>).
  </>,
  "Come back and paste it above."
];

const COMPUTER_STEPS: ReactNode[] = [
  "Open maps.google.com and find your office.",
  "Right-click on the building.",
  "Click the numbers at the top of the menu (like 19.1136, 72.8697). They're copied.",
  "Paste them above."
];

const GuideCard: FunctionComponent<{ title: string; steps: ReactNode[] }> = ({ title, steps }) => (
  <div className="rounded-lg border border-solid border-neutral-5 bg-white p-3">
    <div className="text-sm font-medium text-neutral-10">{title}</div>
    <ol className="mt-2 mb-0 list-decimal space-y-1 pl-4 text-xs text-neutral-8">
      {steps.map((step, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <li key={index}>{step}</li>
      ))}
    </ol>
  </div>
);

/** Collapsible "how do I get the link?" help under the office location input. Open by default. */
const OfficeLocationGuide: FunctionComponent = () => {
  const [open, setOpen] = useState(true);
  return (
    <div className="mt-3 rounded-lg border border-solid border-neutral-5 p-3">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen(prev => !prev)}
        className="flex w-full cursor-pointer items-center justify-between border-0 bg-transparent p-0 text-sm font-medium text-neutral-8"
      >
        <span className="flex items-center gap-2">
          <HiOutlineQuestionMarkCircle size={18} />
          How do I get the link?
        </span>
        {open ? <HiChevronUp size={18} /> : <HiChevronDown size={18} />}
      </button>
      {open && (
        <div className="mt-3">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <GuideCard title="On your phone" steps={PHONE_STEPS} />
            <GuideCard title="On a computer" steps={COMPUTER_STEPS} />
          </div>
          <div className="mt-3 rounded-lg bg-yellow-50 p-2 text-xs text-yellow-700">Pin the building itself, not the area or city.</div>
        </div>
      )}
    </div>
  );
};

export default OfficeLocationGuide;
